import gift from '../assets/svg/gift.svg'
import devices from '../assets/svg/dev.svg'
import tv from '../assets/svg/tv.svg'
import earth from '../assets/svg/earth.svg'
import backgroundTop from '../assets/svg/background-top.svg'

export const introContent = {
  title: "Более 270 телеканалов в прямом эфире",
  description: "Национальные, познавательные, детские, кино, спортивные, новостные и многие другие каналы",
  button: "Протестировать 7 дней бесплатно",
  background: backgroundTop,
  advantages: [
    {
      id: 1,
      title: "Бесплатный тест",
      description: "7 дней бесплатного тестового просмотра",
      icon: gift
    },
    {
      id: 2,
      title: "5 устройств = 1 подписка",
      description: "Подключайте 5 устройств в одной подписке",
      icon: devices
    },
    {
      id: 3,
      title: "Архив трансляций",
      description: "Смотрите 7 дней телеэфира в записи",
      icon: tv
    },
    {
      id: 4,
      title: "Без привязки к месту",
      description: "Смотрите любимые фильмы и передачи в любой точке мира",
      icon: earth
    },
  ],
}

export const allDevicesContent = {
  title: "Смотрите на разных устройствах",
  description: "Подключайте подписку FULL и смотрите любимые каналы на 5 устройствах, среди которых: телевизор, компьютер, планшет или смартфон",
  button: "Протестировать 7 дней бесплатно",
}

export const rateContent = {
  price: "1€",
  title: "Покупая подписку более, чем на 6 месяцев",
  button: "Подключить тариф",
}

export const channelsContent = {
  title: "ТВ - каналы",
  description: "Национальные, познавательные, детские, кино, спортивные, новостные и многие другие телеканалы",
  categories: [
    {
      id: 1,
      name: "Популярные",
    },
    {
      id: 2,
      name: "Национальные",
    },
    {
      id: 3,
      name: "Познавательные",
    },
    {
      id: 4,
      name: "Кино",
    },
    {
      id: 5,
      name: "Спорт",
    },
    {
      id: 6,
      name: "Детские",
    },
    {
      id: 7,
      name: "Музыкальные",
    },
    {
      id: 7,
      name: "Новостные",
    },
  ]
}

export const faqContent = [
  {
    id: 1,
    question: 'Как подключить подписку OTTCLUB или продлить ее?',
    answer: 'Подписку OTTCLUB можно подключить, сказав "OTTCLUB, включи себя!" или продлить, подкладывая монетки в порт USB.'
  },
  {
    id: 2,
    question: 'Как смотреть одновременно на разных устройствах?',
    answer: 'Чтобы смотреть на разных устройствах, нужно волшебное заклинание: "OTTALOHOMORA!" и носить телевизор с собой.'
  },
  {
    id: 3,
    question: 'Какая скорость соединения необходима для просмотра каналов?',
    answer: 'Для просмотра каналов хватит скорости "Постоянное внимание на экране" или "Стабильный щелчок пальцем".'
  },
  {
    id: 4,
    question: 'Как смотреть OTTCLUB на телевизоре Samsung?',
    answer: 'На телевизоре Samsung смотреть так: Кабель воткни, кнопку нажми, на диване расслабься.'
  },
  {
    id: 5,
    question: 'Как посмотреть передачу, которая была в эфире ранее?',
    answer: 'Чтобы посмотреть передачу из прошлого, вызовите доктора Ктона и используйте воронку времени. Помните про попкорн!'
  },
  {
    id: 6,
    question: 'Как работает бесплатный тестовый период?',
    answer: 'Бесплатный тестовый период - это как пиратский клад, но только на экране. Нажми "Пиратская кнопка" и наслаждайся!'
  },
]